import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Listing.scss";
import CommonService from "../../../../services/common-service";
import AdsService from "../../../../services/ads-service";
import LocalStoreService from "../../../../services/localStore-service";
import VechicleService from "../../../../services/vehicle-service";
import VerticalItem from "../Listing/VerticalItem";

class PopularNewCars extends Component {
  constructor() {
    super();
    this.adsService = new AdsService();
    this.commonService = new CommonService();
    this.localService = new LocalStoreService();
    this.vehicleservice = new VechicleService();
    this.state = {
      listLayoutStyle: "vertical",
      ads: [],
      filterQuery: { featured: 1 },
      titleObj: {},
      sortBy: "",
      query: "",
      category: "",
      pageSize: 20,
      pageNo: 0,
      hasData: "",
    };
  }

  componentDidMount() {
    const { category } = this.props;
    if (category) {
      if (category == "car") {
        this.getNewCars();
      } else {
        this.getNewBikes();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      const { category } = this.props;
      if (category) {
        if (category == "car") {
          this.getNewCars();
        } else {
          this.getNewBikes();
        }
      }
    }
  }

  getNewCars = () => {
    const { pageSize, pageNo, filterQuery, sortBy } = this.state;
    this.vehicleservice
      .getNewCars(pageNo, pageSize, filterQuery, sortBy)
      .then((res) => {
        const { data } = res;
        if (data && data.records && data.records.length) {
          this.setState({
            ads: data.records,
            totalPages: data.totalPages,
            totalAds: data.count,
            limits: data.limits,
            category: "car",
            hasData: true,
          });
        } else {
          this.setState({
            ads: [],
            totalPages: 0,
            totalAds: 0,
            limits: data.limits ? data.limits : {},
            category: "car",
            hasData: false,
          });
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });

    this.vehicleservice
      .getCarSeoCrumb()
      .then((res) => {
        const { data } = res;
        if (data) {
          this.setState({
            seo: data,
          });
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });
  };

  getNewBikes = () => {
    const { pageSize, pageNo, filterQuery, sortBy } = this.state;
    this.vehicleservice
      .getNewBikes(pageNo, pageSize, filterQuery, sortBy)
      .then((res) => {
        const { data } = res;
        if (data && data.records && data.records.length) {
          this.setState({
            ads: data.records,
            totalPages: data.totalPages,
            totalAds: data.count,
            limits: data.limits,
            category: "bike",
            hasData: true,
          });
        } else {
          this.setState({
            ads: [],
            totalPages: 0,
            totalAds: 0,
            limits: data.limits ? data.limits : {},
            category: "bike",
            hasData: false,
          });
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });

    this.vehicleservice
      .getCarSeoCrumb()
      .then((res) => {
        const { data } = res;
        if (data) {
          this.setState({
            seo: data,
          });
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });
  };

  favouriteHandler = () => {
    const { category } = this.state;
    category === "cars" ? this.getNewCars() : this.getNewBikes();
  };

  render() {
    const { ads, totalPages, totalAds, listLayoutStyle, hasData, filterQuery, category, sortBy, banners, limits, titleObj, seo } = this.state;

    return (
      <div id="popular-new-cars" className="section-padding">
        <div className="container only-popular-cars">
          <div className="d-flex justify-content-between">
            <h3 className="mb-0 align-self-center">
              Popular New <span className="text-capitalize">{category}</span>s
            </h3>
            <Link to={`/new-${category}s/search/-/`} className="adp-btn adp-btn-secondary">
              View All
            </Link>
          </div>
          <div className="row popular-listing">
            {ads &&
              ads.slice(0, 8).map((item, i) => {
                return (
                  <div className="col-lg-3 col-md-6 col-6 px-0 main-popular" key={item.i}>
                    <VerticalItem className="new-car-listing-vertical" key={item.id} data={item} onFavourite={this.favouriteHandler} category={category} />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}
export default PopularNewCars;
